module.exports = __webpack_public_path__ + "static/media/google-pixel-xl.983efbf6.jpg";